<template>	
	<svg :style="style" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Frame" clip-path="url(#clip0_4253_86384)">
		<path id="Vector" d="M2.52479 11.4744C0.0255907 13.974 0.0255907 18.0264 2.52479 20.5256L11.474 29.4744C13.9732 31.974 18.0256 31.974 20.5248 29.4744L29.474 20.5256C31.9732 18.026 31.9732 13.9736 29.474 11.4744L20.5248 2.52558C18.0256 0.0259789 13.9732 0.0259789 11.474 2.52558L2.52479 11.4744ZM15.9996 11.2C16.3179 11.2 16.6231 11.3264 16.8481 11.5515C17.0732 11.7765 17.1996 12.0817 17.1996 12.4V14.8H19.5996C19.9179 14.8 20.2231 14.9264 20.4481 15.1515C20.6732 15.3765 20.7996 15.6817 20.7996 16C20.7996 16.3182 20.6732 16.6235 20.4481 16.8485C20.2231 17.0736 19.9179 17.2 19.5996 17.2H17.1996V19.6C17.1996 19.9182 17.0732 20.2235 16.8481 20.4485C16.6231 20.6736 16.3179 20.8 15.9996 20.8C15.6813 20.8 15.3761 20.6736 15.1511 20.4485C14.926 20.2235 14.7996 19.9182 14.7996 19.6V17.2H12.3996C12.0813 17.2 11.7761 17.0736 11.5511 16.8485C11.326 16.6235 11.1996 16.3182 11.1996 16C11.1996 15.6817 11.326 15.3765 11.5511 15.1515C11.7761 14.9264 12.0813 14.8 12.3996 14.8H14.7996V12.4C14.7996 12.0817 14.926 11.7765 15.1511 11.5515C15.3761 11.3264 15.6813 11.2 15.9996 11.2Z" fill="white"/>
		</g>
		<defs>
		<clipPath id="clip0_4253_86384">
		<rect width="32" height="32" fill="white"/>
		</clipPath>
		</defs>
		</svg>
</template>

<script>
export default {
	name: 'simple-type',
	props: {
		width: {
			type: String,
			default: '24px'
		}
	},
	data() {
		return {
			style: {
				width: this.width,
				'vertical-align': 'middle',
				fill: 'currentColor',
				overflow: 'hidden',
			}
		}
	}
}
</script>